import { QueryResult, ServerError } from '@apollo/client';
import React from 'react';
import VoxelAlert from '../../../components/voxel/Alert/VoxelAlert';

export interface DataTimedOutProps {}

export function didQueryTimeout(query: QueryResult<unknown, unknown>) {
  var serverError = query.error?.networkError as ServerError;
  return serverError?.statusCode === 408;
}

export const DataTimedOut: React.FC<DataTimedOutProps> = ({}) => {
  return (
    <div data-screenshot-id="chart-loaded">
      {/* We add the chart-loaded marker so that screenshoting won't get stuck if it happens to end up here */}
      <VoxelAlert severity="error" title="Timeout error">
        The data request might've been too resource intensive. Contact the support team to see if we
        can optimize the request in the future.
      </VoxelAlert>
    </div>
  );
};

export default DataTimedOut;
